import { useState } from 'react';
import { useScrollReveal } from '../../hooks/useScrollReveal';

export interface FaqItem {
  q: string;
  a: string;
}

interface PageFaqProps {
  faqs: FaqItem[];
  headline?: string;
  subheadline?: string;
}

export default function PageFaq({
  faqs,
  headline = 'Transportation Questions',
  subheadline = 'Answered',
}: PageFaqProps) {
  const [open, setOpen] = useState<number | null>(0);
  const ref = useScrollReveal<HTMLDivElement>();

  return (
    <section className="bg-white py-28">
      <div className="max-w-4xl mx-auto px-6">
        <div ref={ref} className="section-reveal">
          <div className="text-center mb-14">
            <span className="text-gold text-xs tracking-widest uppercase font-semibold">Common Questions</span>
            <h2 className="font-display text-4xl md:text-5xl font-bold text-neutral-900 mt-3">
              {headline}<br />
              <span className="text-gold">{subheadline}</span>
            </h2>
            <div className="h-0.5 w-16 bg-gold mx-auto mt-6"></div>
          </div>

          <div className="space-y-0 border-t border-neutral-100">
            {faqs.map((faq, i) => (
              <div key={i} className="border-b border-neutral-100">
                <button
                  onClick={() => setOpen(open === i ? null : i)}
                  className="w-full flex items-start justify-between py-5 text-left cursor-pointer group"
                  aria-expanded={open === i}
                >
                  <span className={`text-sm font-semibold pr-6 leading-relaxed transition-colors ${open === i ? 'text-gold' : 'text-neutral-900 group-hover:text-gold'}`}>
                    {faq.q}
                  </span>
                  <div className={`w-7 h-7 flex items-center justify-center flex-shrink-0 border transition-all duration-300 mt-0.5 ${open === i ? 'border-gold bg-gold' : 'border-neutral-200 group-hover:border-gold'}`}>
                    <i className={`text-xs transition-transform duration-300 ${open === i ? 'ri-subtract-line text-black' : 'ri-add-line text-neutral-400 group-hover:text-gold'}`}></i>
                  </div>
                </button>
                <div className={`overflow-hidden transition-all duration-300 ${open === i ? 'max-h-64 pb-6' : 'max-h-0'}`}>
                  <p className="text-neutral-500 text-sm leading-relaxed">{faq.a}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12 text-center">
            <p className="text-neutral-500 text-sm mb-5">Still have questions? We&apos;re available 24/7.</p>
            <a
              href="tel:+18436422440"
              className="inline-flex items-center gap-2 bg-neutral-900 hover:bg-gold hover:text-black transition-colors text-white font-bold px-12 py-4 text-sm tracking-widest uppercase whitespace-nowrap cursor-pointer"
            >
              <div className="w-4 h-4 flex items-center justify-center"><i className="ri-phone-fill text-sm"></i></div>
              Call (843) 642-2440 Now
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
